declare global {
    interface Window {
        __APP_CONFIG__?: {
            API_SERVER_URL: string;
            API_DOMAIN_URL: string;
            FILE_SERVER_URL?: string;
            RECAPTCHA_SITE_KEY: string;
            RECAPTCHA_SITE_KEY_SECOND: string;
            WEBSOCKET_SERVER_URL: string;
            SWAGGER_DOC_URL: string;
            MODE: string;
        };
    }
}

/**
 * Источник правды для переменных окружения.
 *
 * В production-образе (nginx) значения подставляются runtime'ом через envsubst
 * в /config.js — это позволяет один и тот же docker-образ запускать на разных
 * стендах (staging / production / demo) с разными API endpoint'ами.
 *
 * При локальной разработке через `yarn dev` файл /config.js не существует,
 * поэтому используем fallback на import.meta.env (.env.[mode] файлы).
 */
const cfg = window.__APP_CONFIG__ ?? {
    API_SERVER_URL: import.meta.env.VITE_API_SERVER_URL,
    API_DOMAIN_URL: import.meta.env.VITE_API_DOMAIN_URL,
    FILE_SERVER_URL: import.meta.env.VITE_FILE_SERVER_URL,
    RECAPTCHA_SITE_KEY: import.meta.env.VITE_RECAPTCHA_SITE_KEY,
    RECAPTCHA_SITE_KEY_SECOND: import.meta.env.VITE_RECAPTCHA_SITE_KEY_SECOND,
    WEBSOCKET_SERVER_URL: import.meta.env.VITE_WEBSOCKET_SERVER_URL,
    SWAGGER_DOC_URL: import.meta.env.VITE_SWAGGER_DOC_URL,
    MODE: import.meta.env.MODE,
};

export const __API_BASE_URL__ = cfg.API_SERVER_URL;
export const __API_DOMAIN_URL__ = cfg.API_DOMAIN_URL;
export const __FILE_SERVER_URL__ = cfg.FILE_SERVER_URL;
export const __RECAPTCHA_SITE_KEY__ = cfg.RECAPTCHA_SITE_KEY;
export const __RECAPTCHA_SITE_KEY_SECOND__ = cfg.RECAPTCHA_SITE_KEY_SECOND;
export const __WEBSOCKET_SERVER_URL__ = cfg.WEBSOCKET_SERVER_URL;
export const __MODE__ = cfg.MODE;
